/**
 * Input Schema of Responsavel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import PasswordConfirm from '@/components/PasswordConfirm.vue'

interface SchemaContext<T> {
  model: T
  fieldName: string
}

export class InputResponsavelSenhaSchema extends Schema {
  readonly name = 'InputResponsavel'

  isSenhaResponsavelMatch: boolean | null = null
  isSenhaVisualizadorMatch: boolean | null = null
  isSenhaIntegracaoMatch: boolean | null = null
  private responsavelModel: Responsavel

  constructor(model: Responsavel) {
    super()
    this.responsavelModel = model
  }

  get fieldSet(): FieldSet<Responsavel> {
    if (!this.responsavelModel) {
      return {}
    }
    const fields: FieldSet<Responsavel> = {
      senhaIntegracao: (
        schema: SchemaContext<Responsavel>
      ): FieldComponent => ({
        is: Component.InputText,
        bind: {
          type: 'password',
          model: schema.model.senhaIntegracao,
          label: this.translateFrom(schema.fieldName),
          validation: 'min:6',
        },
      }),
      repeatSenhaIntegracao: (
        schema: SchemaContext<Responsavel>
      ): FieldComponent => ({
        is: PasswordConfirm,
        bind: {
          label: this.translateFrom(schema.fieldName),
          password: schema.model.senhaIntegracao,
          required: Boolean(schema.model.senhaIntegracao),
        },
        on: {
          input: (val: boolean) => (this.isSenhaIntegracaoMatch = val),
        },
      }),
    }

    return fields
  }
}
